export enum AppName {
  Admin = 'admin',
  Consumer = 'consumer',
  Merchant = 'merchant',
  Site = 'site',
  Staff = 'staff',
  Supplier = 'supplier'
}

export enum InstanceTier {
  Shape = 'shape',
  Trust = 'trust',
  Live = 'live'
}

export interface Environment {
  app: AppName;
  instance: InstanceTier | string;
  brandName: string;
  baseUrl: string;
  allowGoogleAnalyticsLog: boolean;
  allowNetworkDrawer: boolean;
  allowPushNotification: boolean;
  allowCrashReporting?: boolean;
  allowBiometricAuth?: boolean;
  gaMeasurementId?: string;
  sentryDsn?: string;
}
